export class Favourite {
    packId: number;
    websiteProductId: number;
    isChecked: boolean;
}